const baseParams = {
    /*
      MISSING PARAMS
      Not in original paramMapping
    */
    // Not sure what this is. Always seems to be set to 1.
    // log: "log",
    // Random number
    // wa_cb: "wa_cb",
    // visitor: { loggedInState: "ls" }
    // guid: "eid",
    // clientId: 2.0.4
    // Not sure what this is. Always seems to be set to 1.
    // e: "e",
    visitor: {
        visitorId: 'v1',
        visitorType: 'vt',
        profileId: 'pid',
        adobeData: 'ad',
        loggedInState: 'ls',
        mid: 'mid',
    },
    site: 'st',
    cacheBuster: 'wa_cb',
    app: {
        version: 'av',
        channel: 'ch',
    },
    screen: {
        url: 'url',
        screenId: 'pg_name',
        pageTitle: 'pt',
        referrer: 'rf',
    },
    device: {
        screenRes: 'sr',
        browserRes: 'br',
        colorDepth: 'cd',
        javaScriptVer: 'jv',
    },
    location: {
        timezone: 'tz',
        tz_offset: 'tzo',
    },
    eventType: 'et',
};
export default baseParams;
//# sourceMappingURL=baseParams.js.map